import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

export interface NotificationData {
	title: string;
	body: string;
	icon?: string;
	data?: any;
}

@Component({
	selector: 'app-notification-dialog',
	templateUrl: './notification-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./notification-dialog.component.scss'],
	imports: [CdkScrollable, MatDialogContent, NgIf, MatIcon, MatIconButton],
})
export class NotificationDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<NotificationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: NotificationData
	) {}

	onViewClick(): void {
		this.dialogRef.close({ action: 'view', data: this.data });
	}

	onClose(): void {
		this.dialogRef.close({ action: 'close' });
	}
}
